import { createSelector } from "@reduxjs/toolkit";
import { routeSlice } from "./Core/routeSlice";
import { authSlice } from "./authSlice";
import { personnelSlice } from "./authorization/personnelSlice";
import { labelTemplateSearchSlice } from "./customerInformation/labelTemplateSearch";
import { openMediaResearchSlice } from "./open-media-research/openMediaResearchSlice";
import { destructionDetailDeliverySlice } from "./request-module/destructionDetailDeliverySlice";
import { mdrSearchSlice } from "./request-module/mdrSearchSlice";
import { mediaRequestDetailSlice } from "./request-module/mediaRequestDetailSlice";
import { mediaRequestSearchSlice } from "./request-module/mediaRequestSearchSlice";
/*
 * Actions
 */
export const {
  setAuthInfo,
  removeAuthInfo,
  updateBranch,
  setIRMEmployeeInfo,
  setIRMEmployeeGetError,
  logoutSuccess,
  setAssignedBranches,
  setCurrentBranch,
  setRoleAccess,
  setLoggedUserData,
  updateLoggedUserData,
  setTimeZoneOffset,
  setBranchLocale,
  setError,
  setLocations,
  clearError
} = authSlice.actions;

export const {
  detailDeliveryRequestHeaderObj,
  detailDeliveryRequestSaveFetch,
  deliveryInstructionCommentFetch
} = destructionDetailDeliverySlice.actions;

export const { resetRequestPersistedData, saveBeforeNavigateToRequest } =
  mediaRequestSearchSlice.actions;

export const { resetMDRequestPersistedData, saveBeforeNavigateToMDRequest } =
  mdrSearchSlice.actions;

export const {
  resetMaintenancePersistedData,
  saveBeforeNavigateToMaintenance,
  removeDeleteTablePersistedData
} = labelTemplateSearchSlice.actions;

// media request detail actions
export const {
  resetMediaRequestDetail,
  setClearRequest,
  setRefetch,
  displayExitModal,
  cancelExitProcedure,
  cancelSaveProcedure,
  setErrorMessage,
  setInfoMessage,
  removeErrorMessage,
  removeInfoMessage,
  setActiveTab,
  setNextTab,
  setLockedTab,
  setActionId,
  setOpenMedias,
  addOpenMedia,
  addOpenMedias,
  addOpenMediaSelectedFromPossibleMatches,
  removeOpenMedia,
  setContainers,
  addContainer,
  setTransports,
  assignTransport,
  setRequestNewItemType,
  setNextRequestNewItemType,
  setContainerLogicalVaults,
  setTransportLogicalVaults,
  setContainerMediaTypes,
  setTransportMediaTypes,
  setIssueContainersOrTransports,
  addIssueContainerOrTransport,
  updateIssueContainerOrTransport,
  removeIssueContainerOrTransport,
  setBillForInsertsFlag,
  setExtraInserts,
  addExtraInsert,
  updateExtraInsert,
  removeExtraInsert,
  setExtraItems,
  setIssueContainersOrTransportsAndInserts,
  setDeletableContainers,
  addDeletableContainer,
  removeDeletableContainer,
  setOtherComment
} = mediaRequestDetailSlice.actions;

// route actions
export const {
  resetRouteState,
  setHaveChanges,
  setShowConfirmationModal,
  cancelConfirmation
} = routeSlice.actions;

// personnel actions
export const { setAuthenticationState } = personnelSlice.actions;

// open media research
export const { saveBeforeNavigate, resetPersistedData } =
  openMediaResearchSlice.actions;

/*
 * Selectors
 */
export const selectAuth = (state) => state.auth;

export const selectRequestDetailDelivery = (state) =>
  state.destructionDetailDeliverySlice;

export const selectMediaRequest = (state) => state.mediaRequestDetail; // media request detail selector

export const selectRoute = (state) => state.route; // route selector

export const selectPersonnel = (state) => state.personnel; // personnel selector

export const openMediaResearchPersit = (state) => state.openMediResearch; // open media reserch selector

export const requestSearchPersit = (state) => state.requestSearch; // request search selector

export const mdrSearchPersit = (state) => state.mdrSearch; // media destruction request search selector

export const labelTemplateSearchPersit = (state) => state.labelTemplateSearch; //label template search selector

export const selectContainerProcessingResearch = (state) =>
  state.containerProcessingResearch; // container processing research selector

export const getLocale = createSelector(
  [
    (state) => state.auth.localeByBranch,
    (state) => state.auth.localeByBranchLoaded
  ],
  (localeByBranch, isLoaded) => ({ localeByBranch, isLoaded })
);

export const getTimeZoneOffset = createSelector(
  [
    (state) => state.auth.timeZoneOffset,
    (state) => state.auth.isTimeZoneOffsetLoaded
  ],
  (branchTimeZoneOffset, isOffSetLoaded) => ({
    branchTimeZoneOffset,
    isOffSetLoaded
  })
);

export const getRoleAccess = (state) => {
  return state.auth?.roleAccess || [];
};
